import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Select from 'material-ui/Select'
import { MenuItem } from 'material-ui/Menu';
import Input from 'material-ui/Input';

class SelectUI extends Component {

  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired
      }),
    ).isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
  }

  static defaultProps = {

  }

  render() {
    const { input, options, onChange, disabled, meta: { touched, error }, ...rest } = this.props;
    return (
      <Fragment>
        <Select
          {...input}
          value={input.value}
          onChange={(value) => { input.onChange(value); if (onChange) onChange(value) }}
          onBlur={() => input.onBlur(input.value)}
          input={<Input />}
          disabled={disabled}
          {...rest}
        >
          {options.map((e, i) => <MenuItem key={i} value={e.value}>{e.label}</MenuItem>)}
        </Select>
        {touched && error && <span className="invalid-feedback" style={{ display: 'inherit' }}>{error}</span>}
      </Fragment>
    )
  }
}

export default SelectUI;



// WEBPACK FOOTER //
// ./src/components/SelectUI/index.js